import { useState } from 'react';
import { merge } from '@fluentui/react';
import { useInfiniteQuery, } from '@tanstack/react-query';
import { LIST_DATA_STALE_TIME_MSEC } from '../../../constants';
import { useAnalytics } from '@msrceng/analytics';
import { useOApiReady } from '../util';
import { getNextPageParam } from './getNextPageParam';
import { makeQueryFn } from './makeQueryFn';
import { makeSelect } from './makeSelect';
/**
 * Default options for the OData query on infinite queries.
 */
const defaultOptions = {
    enabled: true,
    isAuthRequired: true,
    isVerificationRequired: true,
    useQueryOptions: {
        keepPreviousData: true,
    },
};
/**
 * Premade Odata query for "load more" type scenarios and scenarios where
 * you want the list to get bigger every time you press the button or
 * scroll to the end.
 */
export const useODataReadInfiniteApi = (
/** The url path (relative) of this entity on top of the apiRoot */
endpointName, 
/** Query filters & params for the paged GET query included in this definiton */
query = {}, 
/** Additional options */
options, queryKey
// queryKey?: QueryKeyHelper
) => {
    const { appInsights } = useAnalytics();
    const { enabled: isEnabledInOptions, isAuthRequired, pageLength, useQueryOptions, uniqueIdentifier, isVerificationRequired, } = merge({}, defaultOptions, options);
    const [rowCount, setRowCount] = useState();
    const oDataQuery = merge({}, {
        top: pageLength,
    }, query);
    /** Did our gates for verification/auth/etc pass? */
    const isReady = useOApiReady({ isAuthRequired, isVerificationRequired });
    /** Did *all* pre-request checks pass? */
    const enabled = isEnabledInOptions && isReady;
    const queryKeyFromOptions = useQueryOptions === null || useQueryOptions === void 0 ? void 0 : useQueryOptions.queryKey;
    const queryKeyFromInjection = [
        endpointName,
        ...(queryKeyFromOptions || []),
        query,
    ];
    const finalQueryKey = queryKey || queryKeyFromInjection;
    const api = useInfiniteQuery(Object.assign(Object.assign({ retry: false, cacheTime: LIST_DATA_STALE_TIME_MSEC, staleTime: LIST_DATA_STALE_TIME_MSEC, keepPreviousData: true }, useQueryOptions), { queryFn: makeQueryFn(oDataQuery, pageLength, endpointName, uniqueIdentifier), getNextPageParam: getNextPageParam(pageLength, endpointName, rowCount, setRowCount), onError: error => appInsights === null || appInsights === void 0 ? void 0 : appInsights.trackException({
            exception: error,
        }), select: makeSelect(useQueryOptions === null || useQueryOptions === void 0 ? void 0 : useQueryOptions.select), enabled, 
        // This allows the query key to be overridden
        // which is important if you want a heirarchy that
        // doesn't start with the endpointName
        queryKey: finalQueryKey }));
    return Object.assign(Object.assign({}, api), { rowCount });
};
